import {useEffect,useState} from 'react';
type Logos={hasLightLogo:boolean;hasDarkLogo:boolean;useShopLogoOnPublicPages:boolean};
/** Public-facing logo obeys the selected location only. Unconfigured shops use
 * existing ECFS text rather than a fabricated logo.
 */
export function PublicLocationLogo({locationCode}:{locationCode:string}){
  const [logos,setLogos]=useState<Logos|null>(null);
  useEffect(()=>{
    const controller=new AbortController();setLogos(null);
    void fetch('/api/v1/shop/logos?'+new URLSearchParams({location:locationCode}),{
      cache:'no-store',signal:controller.signal,
    }).then(async response=>{
      if(!response.ok)return;
      const body=await response.json() as {ok:boolean;data?:Logos};
      if(body.ok&&body.data&&!controller.signal.aborted)setLogos(body.data);
    }).catch(()=>{});
    return ()=>controller.abort();
  },[locationCode]);
  if(!logos?.useShopLogoOnPublicPages||!logos.hasLightLogo)return <>East Coast Float Spa</>;
  const light='/api/v1/shop/logo?'+new URLSearchParams({location:locationCode,mode:'light'});
  const dark='/api/v1/shop/logo?'+new URLSearchParams({location:locationCode,mode:'dark'});
  return <picture>
    {logos.hasDarkLogo&&<source media="(prefers-color-scheme: dark)" srcSet={dark}/>}
    <img className="ecfs-public-shop-logo" src={light} alt="East Coast Float Spa"/>
  </picture>;
}
